import { Autocomplete, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from "@mui/material";
import React from "react";
import i18n from "../../i18n";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import config from "../../config";

class SevenSegmentDisplayTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      seven_segment_displays: this.props?.data || [],
      showModal: false,
      showDeleteWarningModal: false,
      selectedRowIndex: null,
      sevenSegmentDisplayData: {},
      sevenSegmentDisplayModalErrors: {},
    }
  }
  
  async saveSevenSegmentDisplayData() {
    let validateData = await this.validateSevenSegmentDisplayFormField();
    if (Object?.keys(validateData)?.length > 0) {
      return;
    }
    if (this.state.selectedRowIndex === null) {
      let tempData = [...this.props.data];
      tempData.push(this.state.sevenSegmentDisplayData);
      if (this.props?.onChange) {
        this.props?.onChange(tempData);
      }
      this.setState({
        showModal: false
      });
    } else {

      let tempData = [...this.props.data];
      tempData[this.state.selectedRowIndex] = this.state.sevenSegmentDisplayData;
      if (this.props?.onChange) {
        this.props?.onChange(tempData);
      }
      this.setState({
        showModal: false,
        selectedRowIndex: null,
      });
    }
  }
  async validateSevenSegmentDisplayFormField(field) {
    let error = { ...this.state.sevenSegmentDisplayModalErrors };

    if (field == null || field === "type") {
      if (
        !this.state?.sevenSegmentDisplayData?.type ||
        this.state?.sevenSegmentDisplayData?.type === ""
      ) {
        error.type = i18n.t("this_field_is_required");
      } else {
        delete error?.[field];
      }
    }

    if (field == null || field === "server_id") {
      if (
        !this.state?.sevenSegmentDisplayData?.server_id ||
        this.state?.sevenSegmentDisplayData?.server_id === ""
      ) {
        error.server_id = i18n.t("this_field_is_required");
      } else {
        delete error?.[field];
      }
    }
    
    if (field == null || field === "ip") {
      if (!this.state?.sevenSegmentDisplayData?.ip || this.state?.sevenSegmentDisplayData?.ip === "") {
        error.ip = i18n.t("this_field_is_required");
      } else {
        delete error?.[field];
      }
    }
    
    if (field == null || field === "display_id") {
      if (!this.state?.sevenSegmentDisplayData?.display_id || this.state?.sevenSegmentDisplayData?.display_id === "") {
        error.display_id = i18n.t("this_field_is_required");
      } else {
        delete error?.[field];
      }
    }

    this.setState({
      sevenSegmentDisplayModalErrors: error,
    });

    return error;
  }
  async handleSevenSegmentDisplayDelete() {
    let selectedRowIndex = this.state?.selectedRowIndex;
    let tempData = [...this.props.data];
    delete tempData?.[selectedRowIndex];
    var filtered = tempData.filter(function (el) {
      return el != null;
    });
    if (this.props?.onChange) {
      this.props?.onChange(filtered);
    }
    this.setState({
      selectedRowIndex: null,
      showDeleteWarningModal: false,
    });
  }
  render() {
    return (
      <>
        <Grid container spacing={2} className="mb-2 mt-4">
          <Grid item xs={8}>
            <Typography variant="h5">{i18n.t("7_segment_display_details")}</Typography>
          </Grid>
          <Grid
            item
            xs={4}
            className="d-flex"
            direction="row"
            justifyContent="flex-end"
          >
            <Button
              variant="outlined"
              startIcon={<AddIcon />}
              onClick={async () => {
                await this.setState({
                  showModal: true,
                  sevenSegmentDisplayData: {},
                  sevenSegmentDisplayModalErrors: {},
                });
              }}
            >
              {i18n.t("add_display")}
            </Button>
          </Grid>
          <Grid item xs={12}>
            {this.props.data?.length > 0 && (
              <TableContainer component={Paper}>
                <Table aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell align="right">{i18n.t("type")}</TableCell>
                      <TableCell align="right">{i18n.t("server_id")}</TableCell>
                      <TableCell align="right">{i18n.t("ip_address")}</TableCell>
                      <TableCell align="right">{i18n.t("display_id")}</TableCell>
                      <TableCell align="right">Actions</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.props.data?.map((row, index) => (
                      <TableRow
                        key={row?.name}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell align="right">{config.sevenSegmentDisplayTypes.find(type => type.value === row?.type)?.label}</TableCell>
                        <TableCell align="right">{row?.server_id}</TableCell>
                        <TableCell align="right">{row?.ip}</TableCell>
                        <TableCell align="right">{row?.display_id}</TableCell>
                        <TableCell align="right" className="d-flex">
                          {
                            <>
                              <Typography
                                style={{ cursor: "pointer" }}
                                onClick={async (e) => {
                                  e.stopPropagation();
                                  await this.setState({
                                    selectedRowIndex: index,
                                    showDeleteWarningModal: true
                                  });
                                }}
                              >
                                <IconButton color="error">
                                  <DeleteOutlineIcon />
                                </IconButton>
                              </Typography>
                              <Typography
                                style={{ cursor: "pointer" }}
                                onClick={async (event) => {
                                  event.stopPropagation();
                                  await this.setState({
                                    sevenSegmentDisplayData: row,
                                    selectedRowIndex: index,
                                    showModal: true,
                                    sevenSegmentDisplayModalErrors: {},
                                  });
                                }}
                              >
                                <IconButton>
                                  <EditIcon />
                                </IconButton>
                              </Typography>
                            </>
                          }
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </Grid>
        </Grid>
        <Dialog
          open={this.state.showModal}
          fullWidth
          onClose={() => {
            this.setState({
              showModal: false,
            });
          }}
        >
          <DialogTitle id="dialog-title">
            {i18n.t("7_segment_display_details")}
          </DialogTitle>
          <DialogContent>
            <Grid
              container
              spacing={2}
            >
              <Grid item xs={12}>
                <Autocomplete
                  single
                  id="type"
                  options={config.sevenSegmentDisplayTypes}
                  value={this.state.sevenSegmentDisplayData?.type}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      required
                      label={i18n.t("type")}
                      error={
                        this.state.sevenSegmentDisplayModalErrors?.type ? true : false
                      }
                      helperText={this.state.sevenSegmentDisplayModalErrors?.type}
                    />
                  )}
                  onChange={async (option, value) => {
                    await this.setState({
                      sevenSegmentDisplayData: {
                        ...this.state.sevenSegmentDisplayData,
                        type: value.value,
                      },
                    });
                    await this.validateSevenSegmentDisplayFormField("type");
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  required
                  fullWidth
                  type="text"
                  id="server_id"
                  label={i18n.t("server_id")}
                  name="server_id"
                  autoComplete="server_id"
                  onChange={async (e) => {
                    await this.setState({
                      sevenSegmentDisplayData: {
                        ...this.state.sevenSegmentDisplayData,
                        server_id: e?.target?.value,
                      },
                    });
                    await this.validateSevenSegmentDisplayFormField("server_id");
                  }}
                  error={
                    this.state.sevenSegmentDisplayModalErrors?.server_id ? true : false
                  }
                  helperText={this.state.sevenSegmentDisplayModalErrors?.server_id}
                  value={this.state.sevenSegmentDisplayData?.server_id}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  id="ip"
                  fullWidth
                  required
                  label={i18n.t("ip_address")}
                  name="ip"
                  autoComplete="ip"
                  onChange={async (e) => {
                    await this.setState({
                      sevenSegmentDisplayData: {
                        ...this.state.sevenSegmentDisplayData,
                        ip: e?.target?.value,
                      },
                    });
                    await this.validateSevenSegmentDisplayFormField("ip");
                  }}
                  error={this.state.sevenSegmentDisplayModalErrors?.ip ? true : false}
                  helperText={this.state.sevenSegmentDisplayModalErrors?.ip}
                  value={this.state.sevenSegmentDisplayData?.ip}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  id="display_id"
                  fullWidth
                  required
                  label={i18n.t("display_id")}
                  name="display_id"
                  autoComplete="display_id"
                  onChange={async (e) => {
                    await this.setState({
                      sevenSegmentDisplayData: {
                        ...this.state.sevenSegmentDisplayData,
                        display_id: e?.target?.value,
                      },
                    });
                    await this.validateSevenSegmentDisplayFormField("display_id");
                  }}
                  error={this.state.sevenSegmentDisplayModalErrors?.display_id ? true : false}
                  helperText={this.state.sevenSegmentDisplayModalErrors?.display_id}
                  value={this.state.sevenSegmentDisplayData?.display_id}
                />
              </Grid>
              
            </Grid>
          </DialogContent>
          <DialogActions>
            <Stack direction="row" spacing={2}>
              <Button
                variant="outlined"
                onClick={() => {
                  this.setState({
                    showModal: false,
                  });
                }}
              >
                {i18n.t("cancel")}
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  this.saveSevenSegmentDisplayData();
                }}
              >
                {i18n.t("Ok")}
              </Button>
            </Stack>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state?.showDeleteWarningModal}
          onClose={() => {
            this.setState({
              showDeleteWarningModal: false,
            });
          }}
          maxWidth='md'
        >
          <DialogTitle id="alert-dialog-title">{"Delete"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Are you sure of deleting , this action is irreversible.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Stack direction="row" spacing={2}>
              <Button
                variant="outlined"
                onClick={() => {
                  this.setState({
                    showDeleteWarningModal: false,
                    selectedRowIndex: null,
                  });
                }}
              >
                {i18n.t("cancel")}
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() => this.handleSevenSegmentDisplayDelete()}
              >
                {i18n.t("delete")}
              </Button>
            </Stack>
          </DialogActions>
        </Dialog>
      </>
    )
  }
}

export default SevenSegmentDisplayTable